import styled from '@emotion/styled';
import { Link, useLocation } from 'react-router';
import { ErrorPageTmpl } from '../../../../libs/templates/src/template-pages/templates';
import type { ClassifiedError } from '../types';

const Container = styled.div({
  maxWidth: '700px',
  margin: '40px auto',
  padding: '0 16px',
  textAlign: 'left' as const,
});

const Message = styled.p({
  whiteSpace: 'pre-line',
  fontSize: '20px',
  color: '#333',
  lineHeight: 1.5,
  marginBottom: '30px',
});

const CheckListContainer = styled.div({
  textAlign: 'left' as const,
  marginBottom: '24px',
});

const CheckListTitle = styled.div({
  fontSize: '16px',
  fontWeight: 'bold' as const,
  marginBottom: '8px',
});

const CheckList = styled.ul({
  paddingLeft: '24px',
  margin: 0,
  '> li': {
    marginBottom: '8px',
    fontSize: '15px',
    color: '#555',
    textIndent: '-8px',
    paddingLeft: '8px',
  },
});

const SupportText = styled.p({
  fontSize: '14px',
  color: '#666',
  lineHeight: 1.4,
  marginBottom: '24px',
});

const StyledLink = styled(Link)({
  display: 'inline',
  padding: 0,
  backgroundColor: 'transparent',
  color: '#007bff',
  fontSize: '16px',
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'underline',
  },
});

// TODO: AUTH-333 エラーメッセージのローカライズをする
export function AuthErrorView() {
  const location = useLocation();
  const {
    title = '認証エラー',
    summary,
    checklist = [],
  } = location.state as { title: string } & ClassifiedError;

  return (
    <ErrorPageTmpl title={title}>
      <Container>
        <Message id="authentication-error-msg">{summary}</Message>
        {checklist.length > 0 && (
          <CheckListContainer>
            <CheckListTitle>設定不備の可能性があります。以下の項目をご確認ください。</CheckListTitle>
            <CheckList>
              {checklist.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </CheckList>
          </CheckListContainer>
        )}
        <SupportText>解決しない場合は、カスタマーサポートまでお問い合わせください。</SupportText>
        <StyledLink to="/">トップページへ</StyledLink>
      </Container>
    </ErrorPageTmpl>
  );
}
